import styled from 'styled-components';
import { IonHeader } from '@ionic/react';

export const IonHeaderWrapper = styled(IonHeader)``;